'use client'

import React from 'react'
import { ModalSizes } from '../types/modalTypes'
import { Modal, ModalProps } from '../Modal'

export const ConfirmationModal = ({
    isModalVisible = false,
    size = ModalSizes.XS,
    stackedButtons = true,
    setModalVisibility,
    footer,
    title,
    children,
    onHide,
}: ModalProps) => {
    return (
        <Modal
            canBeClosed={false}
            hasBackdrop
            isModalVisible={isModalVisible}
            setModalVisibility={setModalVisibility}
            size={size}
            footer={footer}
            stackedButtons={stackedButtons}
            title={title}
            onHide={onHide}
        >
            {children}
        </Modal>
    )
}
